<template src="./Add.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
  created() {
    this.$store.dispatch("lookups/getLookups");

  },
  computed: {
   socialStatus() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.SocialStatus
      );
    },
    bloodTypes() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.BloodTypes
      );
    },
    diseasesTypes() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.DiseasesTypes
      );
    }, 
    skinIssuesTypes() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.SkinIssuesTypes
      );
    },
    gender() {
      return [
        { value: 2, label: "انثي" },
        { value: 1, label: "ذكر" },
      ]
    },

  },
  data() {
    return {
      vm: {
        
        fullName: null,
        socialStatusId: null,
        bloodTypeId: null,
        address: null,
        birthDate: null,
        phoneNo: null,
        identityNo: null,
        gender: null,
        relativePhoneNo: null,
        relativeName: null,
        // diseases: [],
        // skinProblems: []
      },
    };
  },
  methods: {
    confirm() {
      this.$store
        .dispatch("patients/add", this.vm )
        .then(() => {
          this.back();
        })
        .catch(() => { });
    },
    allowedDates(val) {
      const today = new Date();
     // today.setFullYear(today.getFullYear() - 2);
      const date = new Date(val);
      return date < today;
    },
    back() {
      this.$emit("back");
    },
  },
};
</script>